import { RouteComponentProps, navigate } from "@reach/router";
import * as React from "react";
import { Grid, Tooltip } from "@mui/material";
import { ChevronRight, Circle } from "@mui/icons-material";
import gql from "graphql-tag";
import { useQuery } from "react-apollo";
import styled from "styled-components";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import CentralPageLoader from "../../components/Loading/CentralPageLoader";

const GET_ON_PREM_DATACENTERS = gql`
    query GetOnPremDatacenters($organizationId: ID!) {
        getOnPremDatacentersOfOrganization(organizationId: $organizationId) {
            id
            name
            deviceContexts {
                id
                name
                state
            }
        }
    }
`;

const DeviceCard = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px;
    font-size: 13px;
    min-width: 300px;
    border: 1px solid ${(props) => props.theme.lightGrayBottom};
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    cursor: pointer;
    &:hover {
        background-color: ${(props) => props.theme.grayBackground};
    }
`;

const DatacenterTitle = styled.div`
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 8px;
`;

interface Props extends RouteComponentProps {
    organizationId?: string;
}

export default function OnPremMonitoring({ organizationId }: Props) {
    const { data, loading } = useQuery(GET_ON_PREM_DATACENTERS, {
        variables: { organizationId },
        skip: !organizationId,
    });

    if (loading) {
        return <CentralPageLoader text="Loading on-prem datacenters" />;
    }

    const datacenters = data?.getOnPremDatacentersOfOrganization ?? [];

    return (
        <Grid container spacing={{ xs: 2, md: 3 }} justifyContent="center">
            <Grid item xs={12}>
                <SectionTitle title="On Prem Monitoring" align="left" showBottomBorder />
            </Grid>
            {datacenters.map((dc: any) => (
                <Grid item xs={12} key={dc.id}>
                    <DatacenterTitle>{dc.name}</DatacenterTitle>
                    <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "12px" }}>
                        {(dc.deviceContexts ?? []).map((device: any) => (
                            <DeviceCard
                                key={device.id}
                                onClick={() => navigate(`/app/${organizationId}/monitoring/${device.id}`)}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <Tooltip title={device.state}>
                                        <Circle
                                            style={{
                                                fontSize: "12px",
                                                color:
                                                    device.state === "creating"
                                                        ? "orange"
                                                        : device.state === "created"
                                                        ? "green"
                                                        : "gray",
                                            }}
                                        />
                                    </Tooltip>
                                    <span>{device.id}</span>
                                </div>
                                <ChevronRight style={{ color: "gray", fontSize: "20px" }} />
                            </DeviceCard>
                        ))}
                    </div>
                </Grid>
            ))}
        </Grid>
    );
}
